import type { ChangelogEntry } from "../types";

/** Est. timepris i tilbudseditoren trekker fra innkjøp og viser interne timer. */
export const TILBUD_TIMEPRIS_2026_10: ChangelogEntry = {
  id: "2026-10-12-tilbud-timepris",
  date: "2026-10-12",
  title: "Est. timepris i tilbud tar hensyn til innkjøp",
  summary:
    "Timeprisen nederst i tilbudseditoren trekker nå fra innkjøp på eksterne linjer, og viser hvor mange interne timer den er regnet på.",
  sections: [
    {
      heading: "Tilbud",
      minRole: "user",
      items: [
        {
          title: "Innkjøp påvirker est. timepris",
          kind: "rettet",
          body: "Endret du innkjøpsprisen på en ekstern linje, sto timeprisen i footeren urørt. Nå regnes den som GEEK delt på interne timer, samme formel som «Est. Timepris» på prosjektkortet, så høyere innkjøp gir lavere timepris.",
        },
        {
          title: "Interne timer vises ved siden av timeprisen",
          kind: "nytt",
          body: "Ved siden av est. timepris står nå antall interne timer i tilbudet i parentes, så du ser hva timeprisen er delt på uten å summere linjene selv.",
        },
      ],
    },
  ],
};
